import axios from 'axios';
import { CMD_SERVER_URL, NODE_RED_OFFLINE_URL } from "../env"

// Client para CMD Server (sempre online)
export const cmdApi = axios.create({
  baseURL: CMD_SERVER_URL,
});

// Client para Node-RED (padrão: offline URL, mas podemos trocar depois)
export const nodeRedApi = axios.create({
  baseURL: NODE_RED_OFFLINE_URL,
});

export function setNodeRedBaseURL(url) {
  nodeRedApi.defaults.baseURL = url;
}

cmdApi.interceptors.request.use((config) => {
  try {
    const userSession = JSON.parse(sessionStorage.getItem('user'));
    if (userSession && userSession.token) {
      config.headers.Authorization = `Bearer ${userSession.token}`;
    }
  } catch (e) {
    // se der erro, só segue sem token
  }
  return config;
});